import React from 'react';
import QuestionnaireBuilder from '../modules/supplier-assessment/QuestionnaireBuilder';

export default function SupplierAssessmentESG() {
  return <QuestionnaireBuilder />;
}
